import { isCameraView, type CameraView } from 'app/modules/wallforming/components/scenes/camera-controls/utils/cameraView';

export interface MainCameraView extends CameraView {
    buildingGuid: string;
}

const MAIN_CAMERA_VIEW_STORAGE_KEY = 'wallforming-main-camera-view';

const isMainCameraView = (value: unknown): value is MainCameraView => {
    if (!value || typeof value !== 'object') {
        return false;
    }

    const view = value as Partial<MainCameraView>;
    return typeof view.buildingGuid === 'string' && isCameraView(view);
};

export const writeMainCameraView = (view: MainCameraView) => {
    try {
        sessionStorage.setItem(MAIN_CAMERA_VIEW_STORAGE_KEY, JSON.stringify(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to save main camera view', error);
    }
};

export const readMainCameraView = (buildingGuid: string): MainCameraView | null => {
    try {
        const raw = sessionStorage.getItem(MAIN_CAMERA_VIEW_STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const view: unknown = JSON.parse(raw);
        if (!isMainCameraView(view)) {
            throw new Error('Invalid saved main camera view');
        }
        return view.buildingGuid === buildingGuid ? view : null;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to restore main camera view', error);
        return null;
    }
};
